import { render, staticRenderFns } from "./DaftarKantor.vue?vue&type=template&id=55d0ec2c&scoped=true"
import script from "./DaftarKantor.vue?vue&type=script&lang=js"
export * from "./DaftarKantor.vue?vue&type=script&lang=js"
import style0 from "./DaftarKantor.vue?vue&type=style&index=0&id=55d0ec2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d0ec2c",
  null
  
)

export default component.exports